export enum AppUpdateSource {
  Modal = 'modal',
  SidebarButton = 'sidebar_button',
  MenuItem = 'menu_item',
}
